module.exports = __webpack_public_path__ + "media/images/kaoawase/top/reason3-4f320361db22502b6ccbb44904f8ebca.jpg";